export const ContractAddresses = {
    TokenAddress: "0x7D8E9ba2224004F71957bce04d6506677Cff2fFc",
    // CrowdFundingAddress: "0xd3ff7cB3F47f2284A81ee7a45Ca47bD1c8142363",
    CrowdFundingAddress: "0x93699E4440554B8068E8ce357467F4BAFff37128",
};
